import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { KForm, KFormCheckbox, KFormDatepicker, KFormInput, KFormSpinner } from '@kwixeo/form-vue'
import { emitter, Spinner } from '@kwixeo/interface-vue'
import { BFormGroup } from 'bootstrap-vue'
import { AxiosResponse } from 'axios'
import StockLocationSelect from '../StockLocationSelect/StockLocationSelect.vue'
import { mapGetters } from 'vuex'

@Component({
  components: {
    KForm, KFormInput, KFormDatepicker, KFormSpinner, KFormCheckbox,
    Spinner,
    BFormGroup,
    StockLocationSelect
  },
  computed: {
    ...mapGetters('subscriptions', ['hasModule'])
  }
})
export default class LotForm extends Vue {
  hasModule!: (key: string) => boolean

  @Prop({ required: true }) value!: KwixeoCatalog.ProductLot

  private loading = true
  private lot: Partial<KwixeoCatalog.ProductLot> = {}
  private inStock = false

  get formAction (): string {
    return '/catalog/stock/lot/' + this.lot.id
  }

  mounted (): void {
    this.setLocalValue(this.value)
    this.loading = false
  }

  @Watch('value')
  private setLocalValue (value: KwixeoCatalog.ProductLot): void {
    this.lot = JSON.parse(JSON.stringify(value))

    if (this.lot.product?.stock_tracking_mode === 2) {
      this.inStock = this.lot.stock_quantity === 1
    }
  }

  @Watch('lot.quantity')
  private watchQuantity (quantity: number, oldQuantity: number): void {
    if (oldQuantity === undefined) {
      return
    }
    if (this.lot.stock_quantity === undefined) {
      this.lot.stock_quantity = 0
    }
    this.lot.stock_quantity += quantity - oldQuantity
  }

  private submitComplete (response: AxiosResponse): void {
    emitter.emit('productLotUpdated', response.data)
  }
}
